import Icon from '@mui/icons-material/People';

import { CreateEvent } from './CreateEvent';
import { EditEvent } from './EditEvent';
import { ListEvents } from './ListEvents';

export const EventsResourceConfig = {
  list: ListEvents,
  icon: Icon,
  edit: EditEvent,
  create: CreateEvent,
  name: 'events',
};
